import React from "react";
import { Button } from "@/components/ui/button";
import { Edit, Trash2, Calendar } from "lucide-react";

interface CardActionsProps {
  isOwner?: boolean;
  isActive: boolean;
  onEdit: () => void;
  onDelete: () => void;
  onSchedule: (e: React.MouseEvent) => void;
}

export const CardActions: React.FC<CardActionsProps> = ({
  isOwner,
  isActive,
  onEdit,
  onDelete,
  onSchedule
}) => {
  const handleEditClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    console.log("🚀 [CardActions] Edit button clicked!");
    onEdit();
  };

  const handleDeleteClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    console.log("🚀 [CardActions] Delete button clicked!");
    onDelete();
  };
  
  if (isOwner) {
    // Actions for mentor (owner)
    return (
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={handleEditClick}
          className="flex-1 border-[#00B6F0] text-[#00B6F0] hover:bg-[#00B6F0] hover:text-black"
        >
          <Edit className="h-4 w-4 mr-1" />
          Editar
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={handleDeleteClick}
          className="flex-1 border-red-500 text-red-500 hover:bg-red-500 hover:text-white"
        >
          <Trash2 className="h-4 w-4 mr-1" />
          Excluir
        </Button>
      </div>
    );
  }

  // Action for players (schedule button)
  if (isActive) {
    return (
      <Button 
        onClick={onSchedule}
        className="w-full bg-gradient-to-r from-[#00B6F0] to-[#0077B6] text-black font-bold py-2 rounded-lg hover:opacity-90 transition flex items-center justify-center gap-2"
      >
        <Calendar className="h-4 w-4" />
        Agendar Agora
      </Button>
    );
  }

  // No actions for inactive mentorships
  return null;
};
